import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel, StatusBadge } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function AssetCategoriesPage() {
  const { can } = useAuth();
  const manage = can("assets:config");
  const [items, setItems] = useState([]);
  const [f, setF] = useState({ key: "", label: "" });
  const load = useCallback(() => api.get("/asset-categories").then((r) => setItems(r.data.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  const run = async (fn, msg) => { try { await fn(); toast.success(msg); load(); } catch (e) { toast.error(errorMessage(e)); } };
  return (
    <div data-testid="asset-categories-page">
      <PageHeader overline="Configurazione" title="Categorie asset" description="Elenco configurabile usato per classificare gli asset. Le categorie non si eliminano: si disattivano." />
      <Panel className="p-4 md:p-5">
        {manage && <div className="mb-4 flex flex-wrap gap-2">
          <Input className="w-44" placeholder="chiave (es. ups)" value={f.key} onChange={(e) => setF({ ...f, key: e.target.value.toLowerCase() })} data-testid="category-key" />
          <Input className="w-64" placeholder="Etichetta" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} data-testid="category-label" />
          <Button disabled={f.key.length < 2 || !f.label.trim()} onClick={() => run(() => api.post("/asset-categories", f).then(() => setF({ key: "", label: "" })), "Categoria creata")} data-testid="category-add">Aggiungi</Button>
        </div>}
        <ul className="divide-y divide-line">{items.map((c) => (
          <li key={c.key} className="flex items-center gap-3 py-2.5" data-testid={`category-row-${c.key}`}>
            <span className="w-40 font-mono text-xs text-slate-400">{c.key}</span><span className="flex-1 text-sm text-ink">{c.label}</span>
            <StatusBadge tone={c.active ? "green" : "neutral"}>{c.active ? "Attiva" : "Disattiva"}</StatusBadge>
            {manage && <Button size="sm" variant="ghost" onClick={() => run(() => api.patch(`/asset-categories/${c.key}`, { active: !c.active }), "Categoria aggiornata")} data-testid={`category-toggle-${c.key}`}>{c.active ? "Disattiva" : "Attiva"}</Button>}
          </li>))}</ul>
      </Panel>
    </div>
  );
}
